<template>
  <div class="animated fadeIn">
    <div class="p-4">
      <b-form-group label="Upload Excel File (.xlsx) :">
        <b-form-file
          class="w-50 mb-1"
          @change="selectFile"
          placeholder="Upload File"
          drop-placeholder="Drop file here..."
        ></b-form-file>
      </b-form-group>
      <a
        class="btn btn-primary"
        target="_blank"
        href="https://nipigedev-storage.s3.amazonaws.com/files/customerupload/606705c6ae5ecc0e071a0f6d"
      >
        Download Sample File</a
      >
    </div>
    <div class="text-center mb-1 mt-4">
      <b-button
       type="button"
        class="btn btn-lg btn-success ml-1 w-25"
        :disabled="!selectedFile"
        @click="uploadFile"
      >
       Upload
      </b-button>
    </div>
  </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import { mapActions } from "vuex";
import Vue from "vue";
export default {
  name: "BulkUpload",
  components: {
    ebButton,
  },
  data() {
    return {
      isOverlay: false,
      selectedFile: null,
    };
  },
  methods: {
    ...mapActions({
      bulkImport: "partner/bulkCustomerImport",
    }),
    selectFile(event) {
      setTimeout(() => {
        this.selectedFile = event.target.files[0];
      }, 500);
    },
    async uploadFile() {
      let formdata = new FormData();
      formdata.append("dataFile", this.selectedFile);
      formdata.append("name", new Date().getTime());
      this.showCustomToast();
      this.bulkImport(formdata)
        .then((res) => {
          this.isOverlay = false;
          this.clearCustomToast();
          this.$swal({
            type: "success",
            text: "Bulk Customer Created Successfully!",
          });
          this.selectedFile = null;
        })
        .catch(() => {
          this.loading = false;
          this.isOverlay = false;
        });
    },
    showCustomToast() {
      Vue.toasted.show("Uploading...", {
        type: "info",
        theme: "toasted-primary",
        singleton: true,
        duration: 1000000,
      });
    },
    clearCustomToast() {
      Vue.toasted.clear();
    },
  },
};
</script>
